exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter {\n    width: 100px;\n    height: 27px;\n    font-size: 17px;\n}\n\n.formSubmit {\n    margin-top: 26px;\n}\n\n.date {\n    padding: 6px 6px;\n}\n\ncanvas{\n  height:300px !important;\n}\n\n.text-left{\n    text-align: left !important\n}\n\n.zero-margin-padding{\n    margin:0;\n    padding:0;\n}\n.input-width {\n    width:133px\n}\n\n.custom-margin{\n    margin-top:15px;\n    margin-bottom:15px\n}\n\n.text-center{\n    text-align: center\n}\n\n.input-account{\n    height: 27px;\n    width: 126px;\n}\n\n.input-width{\n    width: 110px;\n}\n\n.nopadding {\n    padding: 0 !important;\n    margin: 0 !important;\n }\n\ntd{\n    vertical-align: middle !important;\n}\n\n.customPage {\n    text-align: center;\n    font-size: 18px;\n}\n\n.customPage .ngx-pagination {\n    margin-top: 15px;\n}\n\n.timesheet-list table td {\n  word-break: break-word;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/timesheets/list-timesheet/list-timesheet.component.css
// module id = ../../../../../src/app/timesheets/list-timesheet/list-timesheet.component.css
// module chunks = main